export default __webpack_public_path__ + "static/media/07.8e6fed29.jpg";